export async function updateOrCleanQuery(ctx, filterValue, filterKey, filterQuery) {
  if (filterValue) {
    await ctx.$updateQuery(ctx.$route.query, { [filterKey]: filterQuery })
  } else {
    await ctx.$cleanQuery(ctx.$route.query, filterKey)
  }
}
